import { SUPERADMINCANDIDATELIST } from "../../ENVIRONMENT";

async function candidateListSorting(token, currentPage, name, order) {
  // api for candidate sorting
  const response = await fetch(
    SUPERADMINCANDIDATELIST + `?limit=6&page=${currentPage}&${name}=${order}`,
    {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${
          token ? token : sessionStorage.getItem("token")
        }`,
      },
    }
  );
  return response;
}

export { candidateListSorting };
